import * as Yup from "yup";

export const validationSchemas = [

  // ================= STEP 0: PROFILE =================
  Yup.object({
    fullName: Yup.string()
      .min(3, "Name is too short")
      .required("Full name is required"),

    mobile: Yup.string()
      .matches(/^[0-9]{10}$/, "Mobile must be 10 digits")
      .required("Mobile number is required"),

    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),

    pincode: Yup.string()
      .length(6, "Must be 6 digits")
      .required("Pincode required"),

    district: Yup.string().required("District required"),
    state: Yup.string().required("State required"),
  }),

  // ================= STEP 1: OTP =================
  Yup.object({
    otp: Yup.string()
      .length(6, "OTP must be 6 digits")
      .required("OTP is required"),
  }),

  // ================= STEP 2: DEVICE =================
  Yup.object({
    deviceModel: Yup.string().required("Please select your device"),

    brand: Yup.string().required("Brand is required"),

    price: Yup.number()
      .typeError("Price must be a number")
      .positive("Price must be valid")
      .required("Device price is required"),

    serial: Yup.string()
      .required("Serial number is required")
      .matches(/^[0-9]{16}$/, "Serial must be exactly 16 digits"),

    imei: Yup.string()
      .required("IMEI is required")
      .matches(/^[0-9]{16}$/, "IMEI must be exactly 16 digits"),
  }),

  // ================= STEP 3: PLAN =================
  Yup.object({
    productId: Yup.string().required("Please select a protection plan"),
  }),
];


// import * as Yup from "yup";

// export const validationSchemas = [
//   // Step 0: Profile & Address (activeStep === 0)
//   Yup.object({
//     fullName: Yup.string()
//       .min(3, "Name is too short")
//       .required("Full name is required"),
//     mobile: Yup.string()
//       .matches(/^[0-9]{10}$/, "Mobile must be 10 digits")
//       .required("Mobile number is required"),
//     otp: Yup.string()
//       .length(6, "OTP must be 6 digits")
//       .required("Verification required"),
//     email: Yup.string()
//       .email("Invalid email address")
//       .required("Email is required"),
//     pincode: Yup.string()
//       .length(6, "Must be 6 digits")
//       .required("Pincode required"),
//     district: Yup.string().required("District required"),
//     state: Yup.string().required("State required"),
//   }),

//   // Step 1: Device Details (activeStep === 1)
//   // THIS IS LIKELY WHERE YOUR STEP 3 BLOCK IS HAPPENING
//   // Step 1: Device Details
//   Yup.object({
//     deviceModel: Yup.string().required("Please select your device"),

//     brand: Yup.string().required("Brand is required"),

//     price: Yup.number()
//       .typeError("Price must be a number")
//       .positive("Price must be valid")
//       .required("Device price is required"),

//     // ✅ Serial Number: REQUIRED + 16 DIGITS ONLY
//     serial: Yup.string()
//       .required("Serial number is required")
//       .matches(/^[0-9]{16}$/, "Serial number must be exactly 16 digits"),

//     // ✅ IMEI: REQUIRED + 16 DIGITS ONLY
//     imei: Yup.string()
//       .required("IMEI is required")
//       .matches(/^[0-9]{16}$/, "IMEI must be exactly 16 digits"),
//   }),

//   // Step 2: Plan Selection (activeStep === 2)
//   Yup.object({
//     // If your pkg.id is a number, use Yup.number()
//     package: Yup.string().required("Please select a protection plan"),
//   }),
// ];
